export default __webpack_public_path__ + "static/dell-049ccc240741dc792ac069f76035bdfa.png";